import React from 'react';
import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import { bp, hover } from 'Styles/helpers';
import Logo from '../logo';
import Subhead from '../subhead';
import InlineLink from '../inline-link';
import UnstyledList from '../unstyled-list';
import Subscribe from './subscribe';
import Twitter from '../svg/twitter.svg';
import Facebook from '../svg/facebook.svg';
import Instagram from '../svg/instagram.svg';

const Footer = () => {
  const date = new Date().getFullYear();

  return (
    <StyledFooter>

      <FooterLogo>
        <InlineLink href="/" aria-label="Home">
          <Logo />
        </InlineLink>
      </FooterLogo>

      <FooterFormWrap>
        <Subhead styles="margin-bottom: 10px;">Be First</Subhead>
        <FormTitle>Get the latest</FormTitle>

        <Subscribe />
      </FooterFormWrap>

      <LegalList>
        <li>
          &copy; {date} Waves For Water
        </li>
        <li>
          <InlineLink href="/terms-and-conditions">Terms of Site</InlineLink>
        </li>
        <li>
          <InlineLink href={`${process.env.S3_ROOT}/w4w-static/media-kit/W4W_Logos.zip`}>Media Kit</InlineLink>
        </li>
        <li>
          <InlineLink href="/contact-us">Contact Us</InlineLink>
        </li>
        <li>
          <InlineLink href="https://store.wavesforwater.org/collections/all-products">
            Shop
          </InlineLink>
        </li>
        <li>
          <InlineLink href="https://www.elegantseagulls.com">Site By Elegant Seagulls</InlineLink>
        </li>
      </LegalList>

      <SocialList>
        <li>
          <a
            href="https://www.instagram.com/wavesforwater/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            aria-label="Waves for Water Instagram"
          >
            <Instagram />
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/wavesforwater/"
            rel="nofollow noopener noreferrer"
            target="_blank"
            aria-label="Waves for Water Facebook"
          >
            <Facebook />
          </a>
        </li>
        <li>
          <a
            href="https://twitter.com/wavesforwater"
            rel="nofollow noopener noreferrer"
            target="_blank"
            aria-label="Waves for Water Twitter"
          >
            <Twitter />
          </a>
        </li>
      </SocialList>

      <LegalStuff>
        Waves For Water is a registered 501c3 charitable organization
        Federal Tax ID #27-1319189
      </LegalStuff>

      <Attribution>
        <a href="https://www.contentful.com/" rel="nofollow noopener noreferrer" target="_blank">
          <img src="https://images.ctfassets.net/fo9twyrwpveg/44baP9Gtm8qE2Umm8CQwQk/c43325463d1cb5db2ef97fca0788ea55/PoweredByContentful_LightBackground.svg" style={{ maxWidth: '100px', width: '100%' }} alt="Powered by Contentful" />
        </a>
      </Attribution>

    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  padding: 100px 0 40px;
  text-align: center;

  ${screen.below(bp.desktop, `
    padding-top: 80px;
  `)}

  ${screen.below(bp.laptopSm, `
    padding: 60px 20px 30px;
  `)}
`;

const FooterLogo = styled.div`
  width: 152px;
  height: 53px;
  margin: auto;

  a {
    color: ${props => props.theme.black};

    ${css`
      ${props => hover(`
        color: ${props.theme.blue};
      `)}
    `}
  }
`;

const FooterFormWrap = styled.div`
  margin-top: 50px;

  ${screen.below(bp.mobile, `
    margin-top: 30px;
  `)}
`;

const FormTitle = styled.h4`
  font-size: 2.5rem;

  ${screen.below(bp.mobile, `
    font-size: 1.25rem;
  `)}
`;

const LegalList = styled(UnstyledList)`
  font-size: 1rem;

  li { display: inline-block; }

  li:not(:first-of-type) {
    margin-left: 24px;
    position: relative;

    &::before {
      content: "|";
      position: relative;
      left: -12px;
    }
  }

  ${screen.below(bp.mobile, `
    font-size: .6875rem;

    li:not(:first-of-type) {
      margin-left: 12px;

      &::before {
        left: -6px;
      }
    }
  `)}

  a {
    color: inherit;
    text-decoration: none;

    ${css`
      ${props => hover(`
        color: ${props.theme.blue};
      `)}
    `}
  }
`;

const SocialList = styled(UnstyledList)`
  display: inline-block;
  margin: 40px auto;

  ${screen.below(bp.tablet, `
    margin: 20px; auto;
  `)}

  a {
    color: ${props => props.theme.blue};

    ${css`
      ${props => hover(`
        color: ${props.theme.black};
      `)}
    `}
  }

  li { display: inline; } /* stylelint-disable-line no-descending-specificity */

  li:not(:first-of-type) {
    margin-left: 48px;
  }
`;

const LegalStuff = styled.p`
  max-width: 400px;
  margin: auto;
  font-size: .875rem;
  line-height: 1.5;
`;

const Attribution = styled.div`
  margin-top: 40px;
`;

export default Footer;
